import { combineReducers } from "redux";
import { StateType } from "typesafe-actions";
import vehicleTripReducer from 'store/vehicleTripSlice';
import tripReducer from 'store/tripSlice';
import { configureStore } from "@reduxjs/toolkit";
import { reducer as navigationReducer } from "../../navigation/redux/reducers";


export const rootReducer = combineReducers({

   navigation: navigationReducer,

  vehicleTrip: vehicleTripReducer,
  trip: tripReducer,
});

export interface RootState extends StateType<typeof rootReducer> {}



const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});
export default store;
